// extracted by mini-css-extract-plugin
export default {"bookingTableContainer":"BookingTable_bookingTableContainer__iQ+-c","tableContainer":"BookingTable_tableContainer__Vqczz","actionButton":"BookingTable_actionButton__zaaci"};